import {
  DataModelBuilder, SerializationContext, SerializedData,
} from '../../models/dto/dto.js';

import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';
import { VersionRange } from '../../models/core/version-range.js';

export class OpenAccessPassComponent extends Component {
  static readonly TYPE_ID: string = '54c806a1adf1465ab6c657ebf907b760';
  static readonly SCHEMA_VERSION: number = 2;

  constructor(
    private readonly templateId: string,
    public readonly variationId: string | null,
  ) {
    super();
  }

  get $removable(): boolean {
    return false;
  }

  get $typeId(): string {
    return OpenAccessPassComponent.TYPE_ID;
  }

  get $schemaVersion(): VersionRange {
    return VersionRange.between(1, OpenAccessPassComponent.SCHEMA_VERSION);
  }

  // Need it to trigger compilation errors and find all places where things need to updated.
  // Can be refactored back into a public field in some later PR.
  getTemplateId(): string {
    return this.templateId;
  }

  static fromMap(context: SerializationContext, map: SerializedData): OpenAccessPassComponent {
    return new OpenAccessPassComponent(
        MapUtils.getString(map, 'templateId'),
        MapUtils.getStringOrNull(map, 'variationId'),
    );
  }

  toMap(_context: SerializationContext): SerializedData {
    return {
      'templateId': this.templateId,
      'variationId': this.variationId,
    };
  }

  clone(): this {
    return new OpenAccessPassComponent(
        this.templateId,
        this.variationId,
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.templateId === this.templateId && other.variationId === this.variationId;
  }
}

export class OpenAccessPassComponentBuilder extends DataModelBuilder<OpenAccessPassComponent> {
  build(context: SerializationContext, map: SerializedData): OpenAccessPassComponent {
    return OpenAccessPassComponent.fromMap(context, map);
  }

  migrateToCurrentSchemaVersion(context: SerializationContext, map: SerializedData): SerializedData | null {
    const versionRange = MapUtils.getVersionRange(map);

    if(versionRange.contains(OpenAccessPassComponent.SCHEMA_VERSION)) {
      return map;
    }
    if(versionRange.isGreaterThan(OpenAccessPassComponent.SCHEMA_VERSION)) {
      return null; // This data comes from the FUTURE. We have no idea how to migrate it.
    }

    let version = versionRange.to;

    // In this version the [variationId] field of type [string | null] was introduced
    if(version < 2) {
      version = 2;
    }

    map['$schema_version'] = VersionRange.encodedExactly(version);
    return map;
  }
}
